exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.interview-container[data-v-261bab7a] {\n  padding: 80px 40px;\n}\n.interview-container .interview-message[data-v-261bab7a] {\n    margin: auto;\n}\n@media screen and (max-width: 896px) {\n.interview-container[data-v-261bab7a] {\n    padding: 40px;\n}\n}\n@media screen and (max-width: 480px) {\n.interview-container[data-v-261bab7a] {\n    padding: 40px 16px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-261bab7a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/organisms/Interview.vue
// module id = Gh1A
// module chunks = 3